module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.fdf491ce.woff";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.woff
// module id = ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.woff
// module chunks = 0